import styled from 'styled-components';
import { respondTo } from 'assets/styled/breakpoints';
import { COLORS } from 'assets/styled';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: min-content;
  padding: 20rem 15rem;
  height: 100%;
  gap: 20rem;

  ${respondTo.bigPhone`
    width: 100%;
    max-width: 100%;
  `}
`;

export const LogoWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
`;

export const Logo = styled.img`
  max-width: 100%;
  width: 100%;
  height: auto;
  transform: scale(0.8);

  ${respondTo.midTablet`
    max-width: 70%;
    transform: scale(1);
  `}

  ${respondTo.bigPhone`
    max-width: 80%;
  `}
`;

export const Label = styled.label`
  font-size: 45rem;
  color: ${COLORS.BLACK};
  text-align: center;
  margin-bottom: 20rem;

  ${respondTo.smallTablet`
    font-size: 40rem;
  `}

  ${respondTo.bigPhone`
    font-size: 30rem;
  `}
`;
